export default {"src":"/_next/static/media/mc.6c457827.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};